import React, { useState } from "react";
import CTable from "components/common/Table";
import Button from "components/common/Button";
import CheckInDrawer from "./CheckInDrawer";
import Link from "components/common/Link";

const CheckInTable = ({
  toggleDrawer,
  drawerOpen,
  filteredData,
  dropdownData,
  handlecheckinsubmit,
  isLoading,
  page,
  limit,
  totalItems,
  onPageChange,
  checkInDetailsStatus
}) => {
  const [detail, setDetail] = useState("");
  const [editdraweropen, seteditDrawerOpen] = useState("");
  const handlesetdata = (name, details) => {
    toggleDrawer(true);
    seteditDrawerOpen(name);
    setDetail(details);
  };
  // const sortedData = Array.isArray(filteredData)
  // ? filteredData.sort((a, b) => {
  //     if (a.invoice_url && !b.invoice_url) return -1; // a comes first
  //     if (!a.invoice_url && b.invoice_url) return 1;  // b comes first
  //     return 0; // keep original order if both or neither have invoice_url
  //   })
  // : [];
  const columns = [
    {
      field: "customer_name",
      headerName: "Customer Name",

      valueGetter: (v, d) => {
        const customerCheckInDetail = {
          pathname: `/checkIn/customer/details/` + d?.user_id,
          customerId: d?.user_id,
          visit_id: d?.id,
        };
        return (
          <>
            <Link
              href={customerCheckInDetail}
              style={{ textDecoration: "none", color: "#707070" }}
              state={{ visit_id: d?.id }}
            >
              <span>{d.customer_name}</span>
            </Link>
          </>
        );
      },
    },
    {
      field: "session_status",
      headerName: "Trip",
    },
    {
      field: "charging_station",
      headerName: "Charging Station",
    },
    {
      field: "charging_networks",
      headerName: "Network",
    },
    {
      field: "manufacturer_name",
      headerName: "Manufacturer",
    },
    {
      field: "vehicle_model_name",
      headerName: "Model",
    },
    {
      field: "connector_name",
      headerName: "Connector",
    },
    {
      field: "vehicle_variant_name",
      headerName: "Variant",
    },
    {
      field: "date",
      headerName: "Date",
    },
    {
      field: "time",
      headerName: "Charging Time",
    },
    {
      field: "units_charged",
      headerName: "Unit Charged",
    },
    {
      field: "amount",
      headerName: "Amount",
    },
    {
      field: "invoice",
      headerName: "Invoice",
      valueGetter: (v, d) => {

        const manufacturer = {
          id: d?.id,
          station_id: d?.station_id,
          connector_id: d?.connector_id,
          customer_name: d?.customer_name,
          date: d?.date,
          units_charged: d?.units_charged,
          amount: d?.amount,
          time: d?.time,
          user_id: d?.user_id,
          invoice_url: d?.invoice_url,
          charging_station: d?.charging_station,
        };
        return (
          <>
            {
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  minWidth: "100px",
                }}
              >
                {(!manufacturer?.amount || !manufacturer?.units_charged || !manufacturer?.connector_id || !manufacturer?.date || !manufacturer?.time) && (
                  <Button
                    onClick={() => handlesetdata("addDetails", manufacturer)}
                    style={{
                      fontSize: "11px",
                      minWidth: "100px",
                      textTransform: "none",
                    }}
                  >
                    + Add Details
                  </Button>
                )}

                {/* {manufacturer?.invoice_url && (
                  <Button
                    onClick={() => handlesetdata("editDetails", manufacturer)}
                    style={{
                      fontSize: "11px",
                      minWidth: "100px",
                      textTransform: "none",
                    }}
                  >
                    + Edit Details
                  </Button>
                )} */}

                {manufacturer?.invoice_url && (
                  <a href={manufacturer?.invoice_url}>
                    <img
                      src="../download-icon-customer.svg"
                      alt="Download Invoice"
                      style={{ marginLeft: "5px", width: "27px" }}
                    />
                  </a>
                )}
              </div>
            }
          </>
        );
      },
    },
  ];
  return (
    <>
      <CTable
        columns={columns}
        data={filteredData ?? []}
        pagination={true}
        page={page}
        rowsPerPage={limit}
        isLoading={isLoading}
        count={totalItems + 1}
        onPageChange={onPageChange}
      />
      <CheckInDrawer
        editdraweropen={editdraweropen}
        detail={detail}
        connnectorData={dropdownData}
        toggleDrawer={toggleDrawer}
        drawerOpen={drawerOpen}
        handlecheckinsubmit={handlecheckinsubmit}
        checkInDetailsStatus={checkInDetailsStatus}
      />
    </>
  );
};

export default CheckInTable;
